import React, { useState } from 'react';

function RegisterUser() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleRegister = async (e) => {
        e.preventDefault();
        setMessage('Registering...');

        try {
            const endpoint = 'https://vm32axwh9b.execute-api.us-east-1.amazonaws.com/Prod/RegisterUser';
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });


            if (response.ok) {
                const result = await response.json();
                setMessage(`Success: ${result.message ||  'User registered.'}`);
            } else {
                const error = await response.json();
                setMessage(`Error: ${error.message || response.statusText}`);
            }
        } catch (err) {
            setMessage(`Error: ${err.message}`);
        }
    };

    return (
        <form onSubmit={handleRegister}>
            <h2>Register</h2>
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            <button type="submit">Register</button>
            <p>{message}</p>
        </form>
    );
}

export default RegisterUser;
